import React, { useEffect, useState, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ForYouSection } from './components/ForYouSection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { SuccessStoriesSection } from './components/SuccessStoriesSection';
import { FAQSection } from './components/FAQSection';
import { FinalPushSection } from './components/FinalPushSection';
import { BonusSection } from './components/BonusSection';
import { PricingCTA } from './components/PricingCTA';
import { Footer } from './components/Footer';
import { RecentPurchasePopup } from './components/RecentPurchasePopup';
import { SplashScreen } from './components/SplashScreen';
import { AnimatePresence } from 'framer-motion';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (typeof window.fbq === 'function') return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(t);
    window.fbq('init', '2170351770441900');
    window.fbq('track', 'PageView');
  }, []);
  const [showSplash, setShowSplash] = useState(true);
  return <main className="min-h-screen w-full bg-[#111111] text-white overflow-x-hidden font-sans selection:bg-brand-yellow selection:text-black" data-id="element-0">
      <AnimatePresence data-id="element-1">
        {showSplash && <SplashScreen onEnter={() => setShowSplash(false)} data-id="element-2" />}
      </AnimatePresence>

      <HeroSection data-id="element-3" />
      <ForYouSection data-id="element-4" />
      <ProblemSection data-id="element-5" />
      <MechanismSection data-id="element-6" />
      <SuccessStoriesSection data-id="element-7" />
      <FAQSection data-id="element-8" />
      <FinalPushSection data-id="element-9" />
      <BonusSection data-id="element-10" />
      <PricingCTA data-id="element-11" />
      <Footer data-id="element-12" />
      <RecentPurchasePopup enabled={!showSplash} data-id="element-13" />
    </main>;
}